import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import OrganizationAppResource from './OrganizationAppResource';

class OrganizationPlatformBabAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'organization-platform-bab';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'organizations/platforms/babs';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'organizationUuid',
      'header',
      'imageUuid',
      'enabled',
      'partnerText',
      'partnerImageUuid',
      'leftButtonText',
      'leftButtonUrl',
      'rightButtonText',
      'rightButtonUrl',
      'customBab',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      organization:             OrganizationAppResource,
      image:                    FileAppResource,
      partnerImage:             FileAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      organization: 'organization_uuid',
      image: 'image_uuid',
      partnerImage: 'partner_image_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      organizationUuid: {
        type: 'string',
        presence: true,
      },
      header: {
        type: 'string',
        length: {
          maximum: 512,
        },
      },
      imageUuid: {
        type: 'string',
      },
      enabled: {
        type: 'boolean',
        presence: true,
      },
      partnerText: {
        type: 'string',
        length: {
          maximum: 512,
        },
      },
      partnerImageUuid: {
        type: 'string',
      },
      leftButtonText: {
        type: 'string',
        length: {
          maximum: 512,
        },
      },
      leftButtonUrl: {
        type: 'string',
        url: {
            message: 'must be a valid URL. (e.g. https://www.example.com)',
        }
      },
      rightButtonText: {
        type: 'string',
        length: {
          maximum: 512,
        },
      },
      rightButtonUrl: {
        type: 'string',
        url: {
            message: 'must be a valid URL. (e.g. https://www.example.com)',
        }
      },
      customBab: {
        type: 'boolean',
      },
    };
  }

}

export default OrganizationPlatformBabAppResource;
